export const RESET_ALERTS = "reset_alerts";

const resetAlerts = () => {
	return async dispatch => {
		// no request being made because this maps the result of a socket io connection to the redux store
		dispatch({
			type: RESET_ALERTS,
		});
	};
};

export { resetAlerts };
